var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 39,
    viewBox: "0 0 48 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.606 0.901998C17.998 0.901998 21.328 2.54 23.596 5.816C25.864 9.056 26.998 13.736 26.998 19.856C26.998 25.976 25.846 30.674 23.542 33.95C21.274 37.226 17.962 38.864 13.606 38.864C9.25 38.864 5.938 37.226 3.67 33.95C1.402 30.674 0.268 25.976 0.268 19.856C0.268 13.736 1.402 9.056 3.67 5.816C5.938 2.54 9.25 0.901998 13.606 0.901998ZM13.606 6.626C12.31 6.626 11.266 7.058 10.474 7.922C9.682 8.75 9.088 10.136 8.692 12.08C8.332 13.988 8.152 16.58 8.152 19.856C8.152 23.132 8.332 25.742 8.692 27.686C9.088 29.594 9.682 30.98 10.474 31.844C11.266 32.672 12.31 33.086 13.606 33.086C14.902 33.086 15.946 32.672 16.738 31.844C17.53 31.016 18.124 29.648 18.52 27.74C18.916 25.796 19.114 23.168 19.114 19.856C19.114 16.508 18.916 13.88 18.52 11.972C18.124 10.028 17.53 8.66 16.738 7.868C15.946 7.04 14.902 6.626 13.606 6.626ZM47.8239 1.604V38H40.3179V9.164L32.3259 14.078L28.9779 8.894L41.0739 1.604H47.8239Z",
    fill: "#303981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.0906f270e61218e21dc1d1c35ab7c5ac.svg";
export { ForwardRef as ReactComponent };